var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useCallback, useState } from 'react';
import { FIELD_NAMES, STATUS_VALUES, VISIBILITY_VALUES } from '../../../interfaces';
import { useCrossTenantCheck } from '../../../hooks';
export var useCreateListFormState = function () {
    var _a;
    var isCrossTenant = useCrossTenantCheck().isCrossTenant;
    var initialState = (_a = {},
        _a[FIELD_NAMES.LIST_NAME] = '',
        _a[FIELD_NAMES.DESCRIPTION] = '',
        _a[FIELD_NAMES.STATUS] = STATUS_VALUES.ACTIVE,
        _a[FIELD_NAMES.VISIBILITY] = VISIBILITY_VALUES.SHARED,
        _a[FIELD_NAMES.RECORD_TYPE] = '',
        _a);
    var _b = useState(initialState), state = _b[0], setState = _b[1];
    var onValueChange = useCallback(function (rawValue) {
        var _a, _b;
        var value = __assign({}, rawValue);
        if (isCrossTenant(value[FIELD_NAMES.RECORD_TYPE])) {
            value = __assign(__assign({}, value), (_a = {}, _a[FIELD_NAMES.VISIBILITY] = VISIBILITY_VALUES.PRIVATE, _a));
        }
        else {
            value = __assign(__assign({}, value), (_b = {}, _b[FIELD_NAMES.VISIBILITY] = VISIBILITY_VALUES.SHARED, _b));
        }
        setState(function (prevState) {
            return __assign(__assign({}, prevState), value);
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [state]);
    var hasDirtyFields = Boolean(JSON.stringify(initialState) !== JSON.stringify(state));
    var crossTenantType = isCrossTenant(state[FIELD_NAMES.RECORD_TYPE] || '');
    return {
        state: state,
        onValueChange: onValueChange,
        hasChanges: hasDirtyFields,
        crossTenantType: crossTenantType
    };
};
